module.exports = require('./ui/overlays/controls.template');